import type { GroupAnalysis } from '@cli-types/next-adapter/forms.js'
import { pluralize, toPascalCase } from '@cli-utils/text.js'

export function buildGroupRelState(analysis: GroupAnalysis): string {
  const relationshipOpenState = analysis.relFields
    .map((f) => {
      return `  const [${f.name}Open, set${toPascalCase(f.name)}Open] = React.useState(false)`
    })
    .join('\n')
  const relationshipDataState = Array.from(
    new Set(analysis.relFields.map((field) => field.relationship).filter(Boolean))
  )
    .map((relationship) => {
      const relPlural = toPascalCase(pluralize(relationship || ''))
      return `  const { data: ${relationship}Data } = use${relPlural}()`
    })
    .join('\n')

  return [relationshipOpenState, relationshipDataState].filter(Boolean).join('\n')
}
